import { Logo } from '@fast-radius/shared-ui';
import React, { useContext, useEffect, useRef, useState } from 'react';

import { logout } from 'fr-shared/auth';
import { AlertContext, UserContext, useUserAnalyticsContext } from 'fr-shared/context';

import { AlertBanner, Button, Card } from 'portal/components';
import styles from 'portal/index.module.css';

const PendingApproval = ({ denied = false }: { denied?: boolean }) => {
  const userAnalyticsRef = useRef(useUserAnalyticsContext());
  const { setAlert } = useContext(AlertContext);
  const { user } = useContext(UserContext) as any as { user: { email: string } };
  const [loggingOut, setLoggingOut] = useState(false);

  useEffect(() => {
    userAnalyticsRef.current.track(denied ? 'Signup Denied' : 'Pending Admin Approval');
  }, [userAnalyticsRef, denied]);

  const handleLogout = () => {
    setLoggingOut(true);
    logout().catch(() => {
      setLoggingOut(false);
      setAlert({
        message: 'An unexpected error occurred. Please refresh and try again.',
        color: 'danger',
      });
    });
  };

  return (
    <div className="theme-dark bg-gradient">
      <div className={styles.Unauthenticated}>
        <div className={styles.Centered}>
          <div>
            <AlertBanner />
            <Logo className="mt-2 mb-4" fill="white" />
            <Card size="lg">
              <h1 className="h6 text-light mb-4">
                {denied ? 'Your account request was denied' : 'Your account is pending approval'}
              </h1>
              <p className="mb-1">
                Thanks for signing up, <span className="text-light">{user.email}</span>.
              </p>
              <p>
                {denied
                  ? "An admin has reviewed your account and it wasn't approved for access. If you believe this is a mistake, please contact us."
                  : "An admin needs to approve your account before you can access the dashboard. We'll let you know as soon as you're in."}
              </p>
              <div>
                <Button outline loading={loggingOut} onClick={handleLogout}>
                  Log out
                </Button>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingApproval;
